<template>
    <v-card flat>
        <v-tabs v-model="tab">
            <v-tab>Cadastro</v-tab>
            <v-tab>Item Two</v-tab>
            <v-tab>Item Three</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item>
                <subscribe-form/>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>
                    <v-card-text>bbb</v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>
                    <v-card-text>ccc</v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>
<script>
// import { mapState } from 'vuex'
import SubscribeForm from '../../components/admin/config/SubscribeForm.vue'
export default {
    components: { SubscribeForm },
    data () {
      return {
        tab: null,
        items: [
          'web', 'shopping', 'videos', 'images', 'news',
        ],
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      }
    },
}
</script>